import {createModel} from '@@/package/utils/ModelUtil';
import {ContactInquireType} from "~~/package/mapper/contact/model/ContactInquireType";
import {ContactModel} from "~~/package/mapper/contact/model/ContactModel";
import {ContactType} from "~~/package/mapper/contact/model/ContactType";

export class RecruitmentModel extends ContactModel {
    constructor(
        public category: ContactType = ContactType.RECRUITMENT,
        public inquireType: ContactInquireType = ContactInquireType.ENTERPRISE_ADOPTION,
        public companyName: string = "",
        public managerName: string = "",
        public companyContactInfo: string = "",
        public fullName: string = "",
        public applicantContactInfo: string = "",
        public jobPosition: string = "",
        public jobDescription: string = "",
        public testDate: string = ""
    ) {
        super();
    }

    public static create(model: Partial<ContactModel>): ContactModel {
        return createModel<ContactModel>(ContactModel, {
            ...model
        });
    }
}

export class IsNullCheckRecruitmentInfo {
    constructor(
      public inquireType: boolean = false,
      public companyName: boolean = false,
      public managerName: boolean = false,
      public companyContactInfo: boolean = false,
      public fullName: boolean = false,
      public applicantContactInfo: boolean = false,
      public jobPosition: boolean = false,
      public jobDescription: boolean = false,
      public testDate: boolean = false,
    ) {
    }
}
